<template>
  <img src="@/assets/img/Icons/photo-station.svg" />
</template>

<script>
export default {};
</script>

<style></style>
